import axios from "axios";
import config from "../config";

export const login = (username, password) => {
  return axios
    .post(config.BASE_URL + "/api/user/auth", {
      username,
      password,
    })
    .then((res) => {
      if (res.data.token) {
        localStorage.setItem("user", JSON.stringify(res.data));
      }
      return res.data;
    })
    .catch((err) => {
      return err.response.data;
    });
};

export const webRegister = (data) => {
  return axios
    .post(config.BASE_URL + "/api/user/web", {data})
    .then((res) => {
      if (res.data.token) {
        localStorage.setItem("user", JSON.stringify(res.data));
      }
      return res.data;
    })
    .catch((err) => {
      return err.response.data;
    });
};

export const logout = () => {
  localStorage.removeItem("user");
};

export const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};
